import React from 'react';
import TeamColumn from "./TeamColumn.js";

const TeamBoard = ({ teams, employees,loading }) => {
    return (
        <div style={{ display: 'flex', gap: '16px', padding: '1rem' }}>
            {teams.map(team => (
                <TeamColumn
                    key={team.id}
                    team={team}
                    isLoading={loading === String(team.id)}
                    employees={employees[team.id] || []}
                />
            ))}
        </div>
    );
};

export default TeamBoard;